import { useTheme } from "@mui/material/styles";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { forwardRef } from "react";

/**
 * SvgIcon for Scout — paths match `assets/ScoutIcon.svg`. Same contract as
 * `@mui/icons-material` (forwardRef, `sx`, 24×24 default size). Defaults to the
 * Encamp tent color (brand pumpkin) so the Scout mark matches the logo; pass
 * `color`/`sx.color` to override (e.g. white on a dark surface, or grey for the
 * streaming "thinking" state).
 */
const ScoutIcon = forwardRef<SVGSVGElement, SvgIconProps>(function ScoutIcon(
  { sx, ...props },
  ref
) {
  const theme = useTheme();
  return (
    <SvgIcon
      ref={ref}
      viewBox="0 0 80 80"
      {...props}
      sx={[{ color: theme.palette.scoutIcon }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <path d="M37.5623 1.44523C38.6162 -0.481748 41.3838 -0.481736 42.4377 1.44523L54.8165 24.079C55.0715 24.5452 55.4549 24.9285 55.9211 25.1835L78.5547 37.5623C80.4818 38.6162 80.4818 41.3838 78.5547 42.4377L55.9211 54.8165C55.4549 55.0715 55.0715 55.4549 54.8165 55.9211L42.4377 78.5547C41.3838 80.4817 38.6162 80.4817 37.5623 78.5547L25.1835 55.9211C24.9285 55.4549 24.5452 55.0715 24.079 54.8165L1.44523 42.4377C-0.481737 41.3838 -0.481753 38.6162 1.44523 37.5623L24.079 25.1835C24.5452 24.9285 24.9285 24.5452 25.1835 24.079L37.5623 1.44523ZM45.2944 18.1221C44.8153 17.2462 43.5572 17.2462 43.0782 18.1221L35.9125 31.2241C35.7966 31.436 35.6224 31.6103 35.4105 31.7262L22.3083 38.892C21.4325 39.371 21.4325 40.629 22.3083 41.108L35.4105 48.2739C35.6224 48.3898 35.7966 48.5639 35.9125 48.7758L43.0782 61.8779C43.5572 62.7538 44.8153 62.7538 45.2944 61.8779L52.4601 48.7758C52.576 48.5639 52.7502 48.3896 52.962 48.2737L66.0642 41.108C66.9401 40.629 66.9401 39.371 66.0642 38.892L52.962 31.7262C52.7502 31.6103 52.576 31.436 52.4601 31.2241L45.2944 18.1221Z" />
    </SvgIcon>
  );
});

export default ScoutIcon;
